export default __webpack_public_path__ + "static/media/click.b7e84ff5.wav";